exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-board[data-v-1e1be516]{height:60px;background-color:#b0cffb;color:#175262;overflow:hidden}.info-board__alert[data-v-1e1be516]{margin-top:14px;background-color:#d33;color:#fff;padding:10px;font-size:.92em}.info-board__money[data-v-1e1be516]{font-size:20px;line-height:40px;margin:15px 20px}.info-board__save[data-v-1e1be516]{background-color:#175262;color:#fff;border-radius:0;border:none;font-size:.92em;margin:14px}.fade-enter-active[data-v-1e1be516],.fade-leave-active[data-v-1e1be516]{transition:opacity .5s}.fade-enter[data-v-1e1be516],.fade-leave-to[data-v-1e1be516]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e1be516","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./assets/vue/apps/participate/info-board.vue
// module id = 352
// module chunks = 0 1